import {
  fetchBaseQueryWrapper,
  NO_CACHING,
} from "@/services/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";

export const projectRiskStatusesApi = createApi({
  reducerPath: "projectRiskStatusesApi",
  baseQuery: fetchBaseQueryWrapper(),
  keepUnusedDataFor: NO_CACHING,
  endpoints: (build) => ({
    getProjectRiskStatuses: build.query({
      query: () => 'projectRiskStatuses',
      transformResponse: (response: { data: { id: number; code: string; name: string }[] }) => response.data,
    }),
  }),
});

export const { useGetProjectRiskStatusesQuery } = projectRiskStatusesApi;
